<template>
  <div>
    <template v-if="!book && loader">
      <div
        class="text-center"
      >
        <Loader
          color="color2"
          size="big"
        />
      </div>
    </template>
    <template v-else-if="book">
      <section>
        <div class="container text-center">
          <div class="mx-auto col-md-8">
            <h2 class="font-size-medium font-weight-bold mb-3">Gerencie os arquivos do seu livro</h2>
            <p class="font-size-small">Para fazer o upload do seu livro, clique no botão abaixo e selecione um arquivo no formato .pdf para a caixa abaixo. O tamanho máximo é de 6MB.</p>
            <p class="font-size-small">Os usuários que tiverem acesso ao seu livro poderão fazer o download do arquivo PDF que foi enviado.</p>
            <p class="font-size-small"><strong>Atenção:</strong> Ao subir um arquivo e clicar em publicar, você apagará versões anteriores desse livro!</p>
          </div>

          <!-- FILE EXIBITION -->
          <template v-if="pdfFile">
            <div class="file-upload-card mx-auto d-inline-block shadow-light rounded-regular background-white p-4 text-center font-size-small position-relative mt-4">
              <button type="button" class="btn-remove shadow-default" v-b-modal="`destroy-${pdfFile.id}`">
                <i class="fa fa-close"></i>
              </button>
              <span class="d-block font-size-xLarge">
                <i class="fas fa-file-upload text-color2"></i>
              </span>
              <span class="d-block font-weight-bold">{{ pdfFile.filename }}</span>
              <span class="d-block">{{ pdfFile.filesize | formatFileSize }}</span>
            </div>
            <DestroyBookFileModal
              :book="book"
              :file="pdfFile"
              @file-destroyed="reset"
            />
          </template><!-- END FILE EXIBITION -->
          <!-- PDF FILE SECTION -->
          <template v-else>
            <template v-if="!file">
              <input
                type="file"
                id="file"
                style="display: none;"
                @change="changeFile"
                accept="application/pdf"
              />
              <label for="file" class="create-card-link mx-auto cursor-pointer mt-5">
                <span class="create-card p-4">
                  <span class="content font-weight-bold text-center">
                    <span class="d-block font-size-large">
                      <i class="fa fa-plus-circle"></i>
                    </span>
                    Selecionar arquivo PDF
                  </span>
                </span>
              </label>
            </template>
            <template v-else>
              <div class="file-upload-card mx-auto d-inline-block shadow-light rounded-regular background-white p-4 text-center font-size-small position-relative mt-4">
                <button type="button" class="btn-remove shadow-default" @click="removeFile">
                  <i class="fa fa-close"></i>
                </button>
                <span class="d-block font-size-xLarge">
                  <i class="fas fa-file-upload text-color2"></i>
                </span>
                <span class="d-block font-weight-bold">{{ file.name }}</span>
                <span class="d-block">{{ file.size | formatFileSize }}</span>
              </div>
              <div class="text-center mt-3">
                <p v-if="file.size > 6000000" class="font-weight-bold font-size-small">
                  Tamanho máximo permitido é de 6MB
                </p>
                <Button
                  class="btn-primary mb-3 mb-md-0"
                  type="button"
                  :loading="loader"
                  @click="submit"
                  v-else
                >
                  Salvar arquivo
                </Button>
              </div>
            </template>
          </template><!-- PDF END FILE SECTION -->
        </div>

        <div class="mt-5 text-center">
          <router-link
            class="btn btn-outline-color2"
            :to="{ name: 'books.show', params: { username: book.user.username , slug: book.slug } }"
          >
            Voltar para o livro
          </router-link>
        </div>
      </section>
    </template>
  </div>
</template>

<script>

import BooksService from '@/modules/books/services/books-service'
import NotificationService from '@/modules/notifications/services/notifications-service'
import { checkIfUserIsOwnerOfEntity } from '@/utils'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button'
import DestroyBookFileModal from '@/components/books/DestroyBookFileModal'
import Loader from '@/components/common/Loader/Loader'

export default {
  components: {
    Button,
    DestroyBookFileModal,
    Loader
  },
  data () {
    return {
      book: null,
      loader: false,
      file: null
    }
  },
  metaInfo () {
    return {
      title: 'Faça upload do seu livro'
    }
  },
  created () {
    this.getBook()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    pdfFile () {
      if (!this.book || !this.book.files) return null
      return this.book.files.find(file => {
        return file.type === 'pdf'
      })
    }
  },
  methods: {
    async getBook () {
      this.loader = true
      try {
        const book = await BooksService.getBook(this.$route.params.slug)
        checkIfUserIsOwnerOfEntity(book, this.user)
        this.book = book
      } catch (error) {
        // If there is an error, redirect to home
        this.$router.push('/')
      }
      this.loader = false
    },
    changeFile (e) {
      this.file = e.target.files[0]
    },
    removeFile () {
      this.file = null
    },
    async submit () {
      this.loader = true
      try {
        await BooksService.uploadFile(this.book.id, {
          type: 'pdf',
          file: this.file
        })
        const notification = {
          notification: {
            type: 'success',
            content: 'Livro enviado com sucesso!'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.file = null
        this.book = null
        this.loader = false
        this.getBook()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.loader = false
      }
    },
    reset () {
      this.book = null
      this.loader = false
      this.file = null
      this.getBook()
    }
  }
}
</script>

<style lang="scss" scoped>
.create-card-link {
  max-width: 400px;
}

.file-upload-card {
  .btn-remove {
    position: absolute;
    top: -15px;
    padding: 0;
    border: none;
    background: #fff;
    z-index: 2;
    color: $color4;
    font-size: 18px;
    right: -15px;
    width: 30px;
    height: 30px;
    border-radius: 41px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
